import {
  UpdateCustomerSchema,
  PHONE_REGEX,
  PHONE_VALIDATION_ERROR_MESSAGE,
  CONTACT_EMAIL_REGEX,
  CONTACT_EMAIL_VALIDATION_ERROR_MESSAGE,
  contactRefiner,
} from '@vy/types';
import { oz, isNotEmptyString } from '@vy/utils';

export const UpdateCustomerWithExtendedContactsFieldSchema = UpdateCustomerSchema.extend({
  contacts: oz.array(
    oz
      .object({
        receiveInvoiceEmail: oz.boolean(),
        email: oz.string().regex(CONTACT_EMAIL_REGEX, CONTACT_EMAIL_VALIDATION_ERROR_MESSAGE).optional(),
        name: oz.string().optional(),
        title: oz.string().optional(),
        phone: oz.string().regex(PHONE_REGEX, PHONE_VALIDATION_ERROR_MESSAGE).optional(),
        isFromDb: oz.boolean(),
      })
      .refine((contact) => {
        if (contact.isFromDb) {
          return isNotEmptyString(contact.email);
        }

        return true;
      })
      .refine(contactRefiner.refine, contactRefiner.options),
  ),
});

export type UpdateCustomerWithExtendedContactsField = oz.infer<
  typeof UpdateCustomerWithExtendedContactsFieldSchema
>;
